export default __webpack_public_path__ + "static/media/alipay.4711f73c.png";